import { Root } from '@radix-ui/react-radio-group';
import clsx from 'clsx';
import type { CSSProperties, FunctionComponent, ReactNode } from 'react';

export type RadioGroupProps = {
    readonly children: ReactNode;
    readonly className?: string;
    readonly defaultValue?: string;
    readonly name?: string;
    readonly onValueChange?: (value: string) => void;
    readonly style?: CSSProperties;
    readonly value?: string;
};

export const RadioGroup: FunctionComponent<RadioGroupProps> = ({
    children,
    className,
    defaultValue,
    name,
    onValueChange,
    value,
    ...props
}) => {
    return (
        <Root
            className={clsx('flex flex-col gap-m', className)}
            defaultValue={defaultValue}
            name={name}
            value={value}
            onValueChange={onValueChange}
            {...props}
        >
            {children}
        </Root>
    );
};

export { RadioButton } from './RadioButton';
export type { RadioGroupItemProps } from './RadioGroupItem';
export { RadioGroupItem } from './RadioGroupItem';
